import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IPaged } from 'src/app/_models/common/IPaged';
import { GrievanceService } from 'src/app/shared/services/grievance.service';
import { MediaFileService } from 'src/app/shared/services/media-file.service';
@Component({
  selector: 'app-employer-view',
  templateUrl: './employer-view.component.html',
  styleUrls: ['./employer-view.component.css']
})
export class EmployerViewComponent implements OnInit {

  @Output() closeForm: EventEmitter<any> = new EventEmitter();
  title: string = 'Add Return - 85';
  private readonly PAGE_SIZE = 10;
  userMasterId;
  userMasterForm: FormGroup;
  fileToUpload: File = null;
  iRetursubmission: any;
  recallComment: any;
  Id;
  url;
  serviceRequestDetails: any;
  barWidth: number = 0;
  isProgress: boolean = false;
  isTermsandCondi: boolean = false;
  retpostatuss;
  serviceRequestsForm: FormGroup;
  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id',
    sortDir: 'Desc',
    retururl: 0,
    id: 0,
    title: '',
    description: '',
    serviceRequestId: 0,
    reason3: '',
    isTermsandCondi: ''
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private grievanceService: GrievanceService,
    private mediaFileService: MediaFileService,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private authService: AuthService,
    private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort ? params.sort : 'Id';
        this.query.sortDir = params.sortDir ? params.sortDir : this.query.sortDir;
        this.query.id = params.id ? params.id : '';
        this.query.userMasterId = params.userMasterId ? params.userMasterId : '';
        this.query.serviceFieldId = params.serviceFieldId ? params.serviceFieldId : '';
        this.query.description = params.description ? params.description : '';
        this.query.serviceRequestId = params.serviceRequestId ? params.serviceRequestId : '';
      });
    this.grievanceService.get(this.query.id).subscribe((response: any) => {
      if (response) {
        this.iRetursubmission = response;
      }
    });
  }
  onBackClick() {
    this.router.navigate(['/admin/grievance']);
  }
}